<template>
    <EmptyContentSection
        icon="star"
        :title="$t('profile.section.appraisals.empty.title')"
        :description="$t('profile.section.appraisals.empty.description')"
    >
        <template #action>
            <VJoyHighlight level="info" display-icon icon="info-circle">
                <VJoyWrapper direction="row" justify="space-between" align="center" no-margin row-gap="4">
                    <VJoyText class="empty-appraisals__info-text" preset="primary-300" tag-name="p">
                        {{ $t('profile.section.appraisals.empty.invite.text') }}
                    </VJoyText>
                    <VJoyLink class="empty-appraisals__invite-link" :href="link" target="_blank">
                        {{ $t('profile.section.appraisals.empty.invite.link') }}
                    </VJoyLink>
                </VJoyWrapper>
            </VJoyHighlight>
        </template>
    </EmptyContentSection>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useAsyncData} from '#app';
    import {useHostSettings} from '#imports';
    import {VJoyHighlight, VJoyLink, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';
    import EmptyContentSection from '~/components/section/EmptyContentSection.vue';

    const {data: hostSettings} = await useAsyncData('host-settings', () => useHostSettings());

    const link = computed(() => {
        switch (hostSettings.value?.country.toLowerCase()) {
            case 'de':
                return 'https://help.malt.com/kb/guide/de/wie-lade-ich-meinen-kunden-zu-malt-ein-ehNgV1UFzJ/Steps/2515029';
            case 'fr':
                return 'https://help.malt.com/kb/guide/fr/comment-inviter-mon-client-sur-malt-ehNgV1UFzJ/Steps/2515029';
            case 'nl':
                return 'https://help.malt.com/kb/guide/nl/hoe-nodig-ik-mijn-klant-uit-voor-malt-ehNgV1UFzJ/Steps/2515029';
            case 'es':
                return 'https://help.malt.com/kb/guide/es/como-invito-a-mi-cliente-a-malt-ehNgV1UFzJ/Steps/2515029';
            default:
                return 'https://help.malt.com/kb/guide/en/how-do-i-invite-my-client-to-malt-ehNgV1UFzJ/Steps/2515029';
        }
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .empty-appraisals {
        &__info-text {
            flex: 1 0 150px;
            margin: 0;
        }

        &__invite-link {
            white-space: nowrap;

            @include mq.screen_xs {
                overflow-wrap: anywhere;
                white-space: normal;
            }
        }
    }
</style>
